import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import SiteHeader from './modules/_site-header.js';
import Flyout from './modules/_flyout.js';
import Video from './modules/_video.js'
import Auth from './modules/_auth.js'
import { init as favoritesInit } from "./modules/_favorites.js";

import './base/_object-fit-cover.js';

class Scripts {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();
		new Auth();
	}

	ready() {
		favoritesInit();
		focusWithin('label, form, fieldset');

		this.siteheader = new SiteHeader();
		this.flyout = new Flyout();

		if (this.siteheader.node.classList.contains('is-style-flyout') ) {
			this.siteheader.hamburger.addEventListener('click', () => this.flyout.open('menu'));
			this.siteheader.search.addEventListener('click', () => this.flyout.open('search'));
		}
	}

	resize() {
		if ( ! document.body ) {
			return;
		}
		this.video = new Video();

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}
}

export default new Scripts;
